import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { AuthContext } from "./AuthProvider/AuthProvider.jsx";
import Login from "./pages/Auth/Login.jsx";
import TokenLogin from "./pages/Auth/TokenLogin";
import Dashboard from "./pages/dashboard/Dashboard.jsx";
import Customer from "./pages/customer/Customer";
import PageNotFound from "./pages/PageNotFound";
import AddProduct from "./pages/productBrand/AddProduct.jsx";
import ProductList from "./pages/productBrand/ProductList.jsx";
import CategoryList from "./pages/categories/CategoryList";
import AddCategories from "./pages/categories/AddCategories";
// import AddPayment from "./pages/payment/AddPayment";
import EditProduct from "./pages/productBrand/EditProduct.jsx";
import PaymentList from "./pages/payment/PaymentList";
import CustomerDetails from "./pages/customer/CustomerDetails";
import ProductDetails from "./pages/productBrand/ProductDetails.jsx";
import PaymentDetails from "./pages/payment/PaymentDetails";
// import ListOfMessages from "./pages/messages/ListOfMessages";
// import MessageDetails from "./pages/messages/MessageDetails";
// import CategoryDetails from "./pages/categories/CategoryDetails";
import UpdateCategory from "./pages/categories/UpdateCategory";
import FulfiledList from "./pages/fulfiled/FulfiledList";
import ErrorPage from "./pages/ErrorPage";
// import HelpPending from "./pages/HelpCenter/HelpPending";
// import HelpPendingDetails from "./pages/HelpCenter/HelpPendingDetails";
import Faq from "./pages/faq/Faq";
import ListOfFaq from "./pages/faq/ListOfFaq";
// import ChangePassword from "./pages/Auth/password/ChangePassword.jsx";
import HelpCenterList from "./pages/Ticket/HelpCenterList.jsx";
import CustomerTransactionHistory from "./pages/customer/CustomerTransactionHistory";
import WalletHistory from "./pages/customer/WalletHistory.jsx";
import OtherBillsHistory from "./pages/customer/OtherBillsHistory.jsx";
import PhysicalBills from "./pages/customer/PhysicalBills.jsx";
// import AddProductToStore from "./pages/storeOld/AddProductToStore.jsx";
// import StoreProductList from "./pages/storeOld/StoreProductList.jsx";
import UpdateSubCategory from "./pages/subcategories/UpdateSubCategory";
import AddSubCategories from "./pages/subcategories/AddSubCategories";
import SubCategoryList from "./pages/subcategories/SubCategoryList";
import ProductCategoryList from "./pages/productCategory/ProductCategoryList.jsx";
import AddProductCategory from "./pages/productCategory/AddProductCategory.jsx";
import EditProductCategory from "./pages/productCategory/EditProductCategory.jsx";
// import ProductCategoryDetails from "./pages/productCategory/ProductCategoryDetails.jsx";
import ProductStockList from "./pages/productStock/ProductStockList.jsx";
import AddProductStock from "./pages/productStock/AddProductStock.jsx";
import EditProductStock from "./pages/productStock/EditProductStock.jsx";
import ProductStockDetails from "./pages/productStock/ProductStockDetails";
import AddStore from "./pages/store/AddStore.jsx";
import StoreList from "./pages/store/StoretList.jsx";
import EditStore from "./pages/store/EditStore.jsx";
import StoreDetails from "./pages/store/StoreDetails.jsx";
import ForgetPassword from "./pages/Auth/password/ForgetPassword.jsx";
import VerifyOTP from "./pages/Auth/password/VerifyOTP.jsx";
import ChangePassword from "./pages/Auth/password/ChangePassword.jsx";
import AdminList from "./pages/Admin/AdminList.jsx";
import AddAdmin from "./pages/Admin/AddAdmin.jsx";
import NotificationStatus from "./pages/Admin/NotificationStatus.jsx";
import TwoFactorAuth from "./pages/Admin/TwoFactorAuth.jsx";
import AdminDetails from "./pages/Admin/AdminDetails.jsx";
import UpdateAdmin from "./pages/Admin/UpdateAdmin.jsx";
import RoleList from "./pages/Roles/RoleList.jsx";
import PermissionList from "./pages/Permissions/PermissionList.jsx";
import UpdatePermission from "./pages/Permissions/UpdatePermission.jsx";
import GetAdminPermissionById from "./pages/Permissions/GetAdminPermisionById.jsx";
import AssignPermissionToAdmin from "./pages/Permissions/AssigPermissionToAdmin.jsx";
import RemovePermissionFromAdmin from "./pages/Permissions/RemovePermissionFromAdmin.jsx";
import ViewRolesPermission from "./pages/Roles/ViewRolesPermission.jsx";
import VendorList from "./pages/vendor/VendorList.jsx";
import VendorDetails from "./pages/vendor/VendorDetails";
import VendorHistory from "./pages/vendor/VendorHistory.jsx";
import UpdateVendor from "./pages/vendor/UpdateVendor";
import CreateRoles from "./pages/Roles/CreateRoles.jsx";
import UpdateRoles from "./pages/Roles/UpdateRole.jsx";
import GrantPermissionToRole from "./pages/Roles/GrantPermissionToRole.jsx";
import AssignRoleToAdmin from "./pages/Roles/AssignRoleToAdmin.jsx";
// import HelpCenterType from "./pages/HelpCenter/HelpCenterType.jsx";
import GetBillsProducts from "./pages/Bills/Airtime/GetBillsProducts.jsx";
import AddImagesToProduct from "./pages/productBrand/AddImagesToProduct.jsx";
import AddImagesToProductStock from "./pages/productStock/AddImagesToProductStock.jsx";
import AddProductStockSupply from "./pages/productStock/AddProductStockSupply.jsx";
import AddProductStockVariant from "./pages/productStock/AddProductStockVariant.jsx";
import UpdateProductStockVariant from "./pages/productStock/UpdateProductStockVariant.jsx";
import AddProductStockVariantSupply from "./pages/productStock/AddProductStockVariantSupply.jsx";
import ProductStockVariantImageUpload from "./pages/productStock/ViewProductStockVariantImageUpload.jsx";
import AddImagesToProductStockVariant from "./pages/productStock/AddImageToProductStockVariant.jsx";
import AddFlashSales from "./pages/flashSales/AddFlashSales.jsx";
import FlashSalesList from "./pages/flashSales/FlashSalestList.jsx";
import EditFlashSales from "./pages/flashSales/EditFlashSales.jsx";
import GetBillers from "./pages/Bills/Biller/GetBillers.jsx";
import AddBillers from "./pages/Bills/Biller/AddBiller.jsx";
import UpdateBillers from "./pages/Bills/Biller/UpdateBillers.jsx";
import SearchBills from "./pages/Bills/Biller/SearchBills.jsx";
import PrivateRoute from "./AuthProvider/PrivateRoute.jsx";
import ProductPropertyList from "./pages/ProductProperty/ProductPropertyList.jsx";
import AddProductProperty from "./pages/ProductProperty/AddProductProperty.jsx";
import EditProductProperty from "./pages/ProductProperty/EditProductProperty.jsx";
import HelpCenterDetails from "./pages/Ticket/HelpCenterDetail.jsx";
import HelpCenterUpdate from "./pages/Ticket/HelpCenterUpdate.jsx";
import AddMessageToCustomerTicket from "./pages/Ticket/AddMessageToCustomerTicket.jsx";
import AdminActLog from "./pages/Admin/AdminActLog.jsx";
import GetAllProducts from "./pages/Bills/Products/GetAllProducts.jsx";
import GetBillersProduct from "./pages/Bills/Biller/GetBillersProduct.jsx";
import Switcher from "./pages/Bills/Switcher/Switcher.jsx";
import GetAllOrders from "./pages/orders/GetAllOrders.jsx";
import UpdateOrders from "./pages/orders/UpdateOrders.jsx";
import OrderById from "./pages/orders/OrderById.jsx";
import GetCompletedOrders from "./pages/orders/GetCompletedOrders.jsx";
import { AuthContext } from "./AuthProvider/AuthProvider.jsx";
import AdminInactivityLogout from "./components/utils/AdminInactivityLogout.jsx";
import React, { useContext } from 'react';
import AppSettingList from "./pages/AppSettings/AppSettingList.jsx";
import UpdateAppSettings from "./pages/AppSettings/UpdateAppSettings.jsx";
import AllSliders from "./pages/Slider/AllSliders.jsx";
import AddSlider from "./pages/Slider/AddSlider.jsx";
import RiderList from "./pages/Riders/RidersList.jsx";
import EditRider from "./pages/Riders/EditRiders.jsx";
import RidersDetails from "./pages/Riders/RidersDetails.jsx";
import ClusterLocationList from "./pages/ClusterLocation/ClusterLocationList.jsx";
import ClusterLocationDetails from "./pages/ClusterLocation/ClusterLocationDetails.jsx";
import CreateClusterLocation from "./pages/ClusterLocation/CreateClusterLocation.jsx";
import UpdateClusterLocation from "./pages/ClusterLocation/UpdateClusterLocation.jsx";
import PendingProductStockList from "./pages/productStock/PendingProductStockList.jsx";
import ProductStockApproval from "./pages/productStock/ProductStockApproval.jsx";
import CreateStockVariantProfit from "./pages/productStock/productStockVariantProfit/CreateStockVariantProfit.jsx";
import CreateProductForm from "./pages/productStock/productComponet/CreateProductForm.jsx";
import ProductStockVariantApproval from "./pages/productStock/ProductStockVariantApproval.jsx";
import PhysicalProductList from "./pages/PhysicalProductDiscount/PhysicalProductList.jsx";
import SecondProductStockApproval from "./pages/productStock/SecondProductStockApproval.jsx";
import SecondProductStockVariantApproval from "./pages/productStock/SecondProductStockVariantApproval.jsx";
import ReturnOrder from "./pages/ReturnedOrder/ReturnOrder.jsx";
import UpdateCustomerReturnOrder from "./pages/ReturnedOrder/UpdateReturnOrder.jsx";
import ReturnOrderDetails from "./pages/ReturnedOrder/ReturnOrderDetails.jsx";
import UpdateReturnOrder from "./pages/ReturnedOrder/UpdateReturnOrder.jsx";
// import EditPhysicalProductList from "./pages/PhysicalProductDiscount/EditPhysicalProductList.jsx";
import CreateProductStockProfit from "./pages/productStock/productStockProfit/CreateProductStockProfit.jsx"
import BranchList from "./pages/operations/branches/BranchList.jsx";
import AddBranch from "./pages/operations/branches/AddBranch.jsx";
import BranchDetails from "./pages/operations/branches/BranchDetails.jsx";
import AssignBranchToHeadOffice from "./pages/operations/branches/AssignBranchToHeadOffice.jsx";
import BranchCustomer from "./pages/operations/branchCustomers/BranchCustomer.jsx";
import BranchCustomerTransactionHistory from "./pages/operations/branchCustomers/BranchCustomerTransactionHistory.jsx";
import BranchCustomerDetails from "./pages/operations/branchCustomers/BranchCustomerDetails.jsx";
import ExpensesList from "./pages/operations/expenses/ExpensesList.jsx";
import BranchProductList from "./pages/operations/branchProduct/BranchProductList.jsx";
import FloatList from "./pages/operations/floats/FloatList.jsx";
import IncentivesList from "./pages/operations/incentives/IncentivesListPending.jsx";
import PriceList from "./pages/operations/productprice/PriceList.jsx";
import WalletList from "./pages/operations/wallets/WalletList.jsx";
import EditBranch from "./pages/operations/branches/EditBranch.jsx";
import BrancActhList from "./pages/operations/branches/BrancActhList.jsx";
import FundBranchWallets from "./pages/operations/branches/FundBranchWallets.jsx";
import GetIncentiveById from "./pages/operations/incentives/GetIncentiveById.jsx";
import GetIncentiveStat from "./pages/operations/incentives/GetIncentiveStat.jsx";
import IncentivesListPending from "./pages/operations/incentives/IncentivesListPending.jsx";
import GetExpenseById from "./pages/operations/expenses/GetExpenseById.jsx";
import BranchSalesHistory from "./pages/operations/branchSales/BranchSalesHistory.jsx";
import BranchSalesHistoryDetails from "./pages/operations/branchSales/BranchSalesHistoryDetails.jsx";
import ViewBranchProductUnit from "./pages/operations/BranchProductUnit/ViewBranchProductUnit.jsx";
import CreateBranchProductUnit from "./pages/operations/BranchProductUnit/CreateBranchProductUnit.jsx";
import EditBranchProductUnit from "./pages/operations/BranchProductUnit/EditBranchProductUnit.jsx";
import BranchProductCat from "./pages/operations/branchProdCat/BranchProductCat.jsx";
import AddBranchProduct from "./pages/operations/branchProduct/AddBranchProduct.jsx";
import EditBranchProduct from "./pages/operations/branchProduct/EditBranchProduct.jsx";
import BranchProductDetails from "./pages/operations/branchProduct/BranchProductDetails.jsx";
import AddBranchProductCategory from "./pages/operations/branchProdCat/AddBranchProductCategory.jsx";
import EditBranchProductCategory from "./pages/operations/branchProdCat/EditBranchProductCategory.jsx";
import BranchProductUnitDetails from "./pages/operations/BranchProductUnit/BranchProductUnitDetails.jsx";
import BranchDashboard from "./pages/operations/dashboard/BranchDashboard.jsx";
import { PortalProvider } from "./AuthProvider/PortalProvider.jsx";
import BranchReportList from "./pages/operations/reports/BranchReportList.jsx";
import BranchCustomerReport from "./pages/operations/reports/BranchCustomerReport.jsx";
import CustomerStatus from "./pages/customer/CustomerStatus.jsx";
import DeliveryPriceList from "./pages/DeliveryMangement/DeliveryPriceList.jsx";
import CreateDeliveryPrice from "./pages/DeliveryMangement/CreateDeliveryPrice.jsx";
import DeliveryPriceDetails from "./pages/DeliveryMangement/DeliveryPriceDetails.jsx";
import EditDeliveryPrice from "./pages/DeliveryMangement/EditDeliveryPrice.jsx";
import PendingProductStockDetails from "./pages/productStock/PendingProductStockDetails.jsx";
import VendorWithdrawaReqList from "./pages/WithdrawalRequest/VendorWithdrawaReqList.jsx";
import VendorWithdrawalApproval from "./pages/WithdrawalRequest/VendorWithdrawalApproval.jsx";
import VendorWithdrawalrequestDetails from "./pages/WithdrawalRequest/VendorWithdrawalrequestDetails.jsx";
import CommissionList from "./pages/Commission/CommissionList.jsx";
import CreateCommission from "./pages/Commission/CreateCommission.jsx";
import EditCommission from "./pages/Commission/EditCommission.jsx";
import CommissionDetails from "./pages/Commission/CommissionDetails.jsx";
import AssignCommission from "./pages/Commission/AssignCommission.jsx";
import WalletsHistory from "./pages/operations/wallets/WalletsHistory.jsx";
import TransactionHistory from "./pages/operations/Transactions/TransactionHistory.jsx";
import AssignProperty from "./pages/ProductProperty/AssignProperty.jsx";
import BranchProductListDetails from "./pages/operations/branchProduct/BranchProductListDetails.jsx";
import GetAllPurchase from "./pages/operations/purchaseItem/GetAllPurchase.jsx";
import GetPendingPurchase from "./pages/operations/purchaseItem/GetPendingPurchase.jsx";
import GetAllRemittance from "./pages/operations/remittance/GetAllRemittance.jsx";
import Remittancedetails from "./pages/operations/remittance/Remittancedetails.jsx";
import GetPendingRemittance from "./pages/operations/remittance/GetPendingRemittance.jsx";
import GetDeductedRemittance from "./pages/operations/remittance/DeductRemittance.jsx";
import GetProcessRemittance from "./pages/operations/remittance/GetProcessRemittance.jsx";
import PendingRemittanceDetails from "./pages/operations/remittance/PendingRemittanceDetails.jsx";
import ProcessRemittanceDetails from "./pages/operations/remittance/ProcessRemittanceDetails.jsx";
import DeductedRemittanceDetails from "./pages/operations/remittance/DeductedRemittanceDetails.jsx";
import BranchStockMonitoring from "./pages/operations/stockMonitoring/BranchStockMonitoring.jsx";
import GetAllSecurityQuestion from "./pages/securityQuestion/GetAllSecurityQuestion.jsx";
import SecurityQuestionDetails from "./pages/securityQuestion/SecurityQuestionDetails.jsx";
import CreateSecurityQuestion from "./pages/securityQuestion/CreateSecurityQuestion.jsx";
import EditSecurityQuestion from "./pages/securityQuestion/EditSecurityQuestion.jsx";
import GetSecurityQuestionStat from "./pages/securityQuestion/GetSecurityQuestionStat.jsx";
import GetBillsDetails from "./pages/Bills/Airtime/GetBillsDetails.jsx";
import HeadOfficeDashboard from "./pages/headOffice/HeadOfficeDashboard.jsx";
import HeadOfficeList from "./pages/headOffice/HeadOfficeList.jsx";
import HeadOfficeDetails from "./pages/headOffice/HeadOfficeDetails.jsx";
import CreateHeadOffice from "./pages/headOffice/CreateHeadOffice.jsx";
import EditHeadOffice from "./pages/headOffice/EditHeadOffice.jsx";
import HeadOfficeInventory from "./pages/headOffice/HeadOfficeInventory.jsx";
import HeadOfficeBranches from "./pages/headOffice/HeadOfficeBranches.jsx";
import AllocateStock from "./pages/headOffice/AllocateStock.jsx";
import HeadOfficePendingDeliveries from "./pages/headOffice/HeadOfficePendingDeliveries.jsx";
import BranchInventoryRequests from "./pages/operations/branchInventoryRequests/BranchInventoryRequests.jsx";
import BranchInventoryRequestDetails from "./pages/operations/branchInventoryRequests/BranchInventoryRequestDetails.jsx";
import BranchInventoryRequestHistory from "./pages/operations/branchInventoryRequests/BranchInventoryRequestHistory.jsx";



const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Login />} />
      {/* <Route element={<PrivateRoutes />}> */}
      <Route path="/login/token" element={<TokenLogin />} />
      {/* <Route path="/admin/dashboard" element={<Dashboard />} /> */}

      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoute >
            <Dashboard />
          </PrivateRoute>
        }
      />
      {/* ======================= customer management=========================== */}
      <Route
        path="/admin/customer"
        element={
          <PrivateRoute requiredPermissions={['customer.view']}>
            <Customer />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/update/status"
        element={
          <PrivateRoute requiredPermissions={['customer.view']}>
            <CustomerStatus />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/customer/transactions/history"
        element={
          <PrivateRoute requiredPermissions={['customer.view']}>
            <CustomerTransactionHistory />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/customer/physical/history"
        element={
          <PrivateRoute requiredPermissions={['customer.view']}>
            <PhysicalBills />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/customer/bills/history"

        element={
          <PrivateRoute requiredPermissions={['customer.view']}>
            <OtherBillsHistory />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/customer/wallet/history"
        element={
          <PrivateRoute requiredPermissions={['wallet.view']}>
            <WalletHistory />
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/customer/details"
        element={
          <PrivateRoute requiredPermissions={['customer.view']}>
            <CustomerDetails />
          </PrivateRoute>
        }
      />
      {/* =======================end of customer managemnt======================= */}
      {/* ========================== product management  =========================*/}
      <Route
        path="/admin/products"
        element={
          <PrivateRoute requiredPermissions={['product.view']}>
            <ProductList />
          </PrivateRoute>
        }
      />
      {/* <Route path="/admin/store/products" element={<StoreProductList />} /> */}
      <Route
        path="/admin/addproduct"
        element={
          <PrivateRoute requiredPermissions={['product.create']}>
            <AddProduct />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/addproduct/images"
        element={
          <PrivateRoute requiredPermissions={['image.add']}>
            <AddImagesToProduct />
          </PrivateRoute>
        }
      />
      {/* <Route path="/admin/store/addproduct" element={<AddProductToStore />} /> */}
      <Route
        path="/admin/product/details"
        element={
          <PrivateRoute requiredPermissions={['product.view']}>
            <ProductDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/edit"
        element={
          <PrivateRoute requiredPermissions={['product.edit']}>
            <EditProduct />
          </PrivateRoute>
        }
      />
      {/*======================= end of product ======================*/}
      {/*=======================  product  property======================*/}
      <Route
        path="/admin/product/property/list"
        element={
          <PrivateRoute requiredPermissions={['property.view']}>
            <ProductPropertyList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/property/update"
        element={
          <PrivateRoute requiredPermissions={['property.edit']}>
            <EditProductProperty />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/property/create"
        element={
          <PrivateRoute requiredPermissions={['property.create']}>
            <AddProductProperty />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/property/assign"
        element={
          <PrivateRoute requiredPermissions={['property.create']}>
            <AssignProperty />
          </PrivateRoute>
        }
      />
      {/*======================= end of product  property======================*/}
      {/*============================ product  category management =================*/}
      <Route
        path="/admin/products/category/list"
        element={
          <PrivateRoute requiredPermissions={['product_category.view']}>
            <ProductCategoryList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/products/category/create"
        element={
          <PrivateRoute requiredPermissions={['product_category.create']}>
            <AddProductCategory />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/category/edit"
        element={
          <PrivateRoute requiredPermissions={['product_category.edit']}>
            <EditProductCategory />
          </PrivateRoute>
        }
      />
      {/* <Route
        path="/admin/product/category/details"
        element={
          <PrivateRoute requiredPermissions={['']}>
            <ProductCategoryDetails />
          </PrivateRoute>
        }
      /> */}

      {/*========================== end of product management=================== */}
      {/*============================== product stock managememt ==================*/}
      <Route
        path="/admin/products/stock/list"
        element={
          <PrivateRoute requiredPermissions={['stock.view']}>
            <ProductStockList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/products/stock/pending"
        element={
          <PrivateRoute requiredPermissions={['stock.view']}>
            <PendingProductStockList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/products/stock/pending/details"
        element={
          <PrivateRoute requiredPermissions={['stock.view']}>
            <PendingProductStockDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/products/stock/create"
        element={
          <PrivateRoute requiredPermissions={['stock.create']}>
            <AddProductStock />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/edit"
        element={
          <PrivateRoute requiredPermissions={['stock.edit']}>
            <EditProductStock />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/details"
        element={
          <PrivateRoute requiredPermissions={['stock.view']}>
            <ProductStockDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/images"
        element={
          // may chnage this permission name later
          <PrivateRoute requiredPermissions={['image.add']}>
            <AddImagesToProductStock />
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/products/stock/variant/update"
        element={
          <PrivateRoute requiredPermissions={['stock.edit']}>
            <UpdateProductStockVariant />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/products/stock/variant/profit"
        element={
          <PrivateRoute requiredPermissions={['stock.create']}>
            <CreateStockVariantProfit />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/variant/images/uploads"
        element={
          <PrivateRoute requiredPermissions={['image.add']}>
            <ProductStockVariantImageUpload />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/variant/add/supply"
        element={
          <PrivateRoute requiredPermissions={['stock.supply']}>
            <AddProductStockVariantSupply />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/variant/images/uploads"
        element={
          <PrivateRoute requiredPermissions={['image.add']}>
            <AddImagesToProductStockVariant />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/profit"
        element={
          <PrivateRoute requiredPermissions={['stock.create']}>
            <CreateProductStockProfit />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/approval"
        element={
          <PrivateRoute requiredPermissions={['stock.create']}>
            <ProductStockApproval />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/second/approval"
        element={
          <PrivateRoute requiredPermissions={['stock.create']}>
            <SecondProductStockApproval />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/variant/approval"
        element={
          <PrivateRoute requiredPermissions={['stock.create']}>
            <ProductStockVariantApproval />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/variant/second/approval"
        element={
          <PrivateRoute requiredPermissions={['stock.create']}>
            <SecondProductStockVariantApproval />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/stock/add/supply"
        element={
          <PrivateRoute requiredPermissions={['stock.supply']}>
            <AddProductStockSupply />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/products/stock/variant/create"
        element={
          <PrivateRoute requiredPermissions={['stock.create']}>
            <AddProductStockVariant />
          </PrivateRoute>
        }
      />
      {/*===================== end of product stock managememt =============================== */}
      {/*=============================== store managemenet ===================================*/}
      {/* ============================== end of store management============================== */}
      <Route
        path="/admin/store/list"
        element={
          <PrivateRoute requiredPermissions={['store.view']}>
            <StoreList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/store/update"
        element={
          <PrivateRoute requiredPermissions={['store.edit']}>
            <EditStore />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/store/details"
        element={
          <PrivateRoute requiredPermissions={['store.view']}>
            <StoreDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/store/create"
        element={
          <PrivateRoute requiredPermissions={['store.create']}>
            <AddStore />
          </PrivateRoute>
        }
      />
      {/* <Route
        path="/admin/store/create"
        element={
          <PrivateRoute requiredPermissions={['store.delete']}>
            <RemoveStore />
          </PrivateRoute>
        }
      /> */}

      {/*======================= category management ===========================================*/}
      <Route
        path="/admin/category/list"
        element={
          <PrivateRoute requiredPermissions={['category.view']}>
            <CategoryList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/category/update"
        element={
          <PrivateRoute requiredPermissions={['category.edit']}>
            <UpdateCategory />
          </PrivateRoute>
        }
      />
      {/* <Route path="/admin/category/details" element={<CategoryDetails />} /> */}
      <Route
        path="/admin/addcategory"
        element={
          <PrivateRoute requiredPermissions={['category.create']}>
            <AddCategories />
          </PrivateRoute>
        }
      />
      {/*  ============================category management =======================================*/}
      {/*================================ sub category ===========================================*/}
      <Route
        path="/admin/subcategory/list"
        element={
          <PrivateRoute requiredPermissions={['subcategory.view']}>
            <SubCategoryList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/subcategory/update"
        element={
          <PrivateRoute requiredPermissions={['subcategory.edit']}>
            <UpdateSubCategory />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/subcategory/create"
        element={
          <PrivateRoute requiredPermissions={['subcategory.create']}>
            <AddSubCategories />
          </PrivateRoute>
        }
      />
      {/*==================================== end of sub category ============================== */}
      {/* ========================= flash sales ======================================== */}
      <Route
        path="/admin/flash/sales/list"
        element={
          <PrivateRoute requiredPermissions={['flash_sales.view']}>
            <FlashSalesList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/flash/sales/create"
        element={
          <PrivateRoute requiredPermissions={['flash_sales.create']}>
            <AddFlashSales />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/flash/sales/update"
        element={
          <PrivateRoute requiredPermissions={['flash_sales.edit']}>
            <EditFlashSales />
          </PrivateRoute>
        }
      />

      {/* ========================= end flash sales ======================================== */}
      {/* ================================orders management ====================================*/}
      <Route
        path="/admin/fullfilled"
        element={
          <PrivateRoute requiredPermissions={['']}>
            <FulfiledList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/payment"
        element={
          <PrivateRoute requiredPermissions={['']}>
            <PaymentList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/payment/details"
        element={
          <PrivateRoute requiredPermissions={['']}>
            <PaymentDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/order/list"
        element={
          <PrivateRoute requiredPermissions={['order.view']}>
            <GetAllOrders />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/order/details"
        element={
          <PrivateRoute requiredPermissions={['order.view']}>
            <OrderById />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/order/update"
        element={
          <PrivateRoute requiredPermissions={['order.edit']}>
            <UpdateOrders />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/customer/order/return"
        element={
          <PrivateRoute requiredPermissions={['order.view']}>
            <ReturnOrder />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/customer/order/return/update"
        element={
          <PrivateRoute requiredPermissions={['order.edit']}>
            <UpdateReturnOrder />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/customer/order/return/details"
        element={
          <PrivateRoute requiredPermissions={['order.view']}>
            <ReturnOrderDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/customer/order/return/update"
        element={
          <PrivateRoute requiredPermissions={['order.edit']}>
            <UpdateCustomerReturnOrder />
          </PrivateRoute>
        }
      />
      {/* <Route
        path="/admin/returned/customer/orders"
        element={
          <PrivateRoute requiredPermissions={['order.return']}>
            <AdminReturnCustomerOrder />
          </PrivateRoute>
        }
      /> */}
      <Route
        path="/admin/order/fulfiled"
        element={
          <PrivateRoute requiredPermissions={['']}>
            <GetCompletedOrders />
          </PrivateRoute>
        }
      />
      {/* ========================= ticket ============================== */}
      <Route
        path="/admin/help/list"
        element={
          <PrivateRoute requiredPermissions={['ticket.view']}>
            <HelpCenterList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/help/details"
        element={
          <PrivateRoute requiredPermissions={['ticket.view']}>
            <HelpCenterDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/help/update"
        element={
          <PrivateRoute requiredPermissions={['ticket.edit']}>
            <HelpCenterUpdate />
          </PrivateRoute>
        }
      />
      {/* ==================== message reply to ticket ================== */}
      <Route
        path="/admin/help/message/add"
        element={
          <PrivateRoute requiredPermissions={['message.send']}>
            <AddMessageToCustomerTicket />
          </PrivateRoute>
        }
      />


      {/*=============================- end of ticket management ==========================*/}

      {/*=============================- end of order management ==========================*/}

      {/* ===================== admin management=========================================== */}
      <Route
        path="/admin/view/list"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <AdminList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/view/details"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <AdminDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/create"
        element={
          <PrivateRoute requiredPermissions={['admin.create']}>
            <AddAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/update"
        element={
          <PrivateRoute requiredPermissions={['admin.edit']}>
            <UpdateAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/activity/log"
        element={
          <PrivateRoute requiredPermissions={['admin.activities']}>
            <AdminActLog />
          </PrivateRoute>
        }
      />
      {/* ===================== end if admin management=========================================== */}
      {/* ====================== Roles and Permission ========================== */}
      <Route
        path="/admin/permission/list"
        element={
          <PrivateRoute requiredPermissions={['permission.view']}>
            <PermissionList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/permission/view/permissions"
        element={
          //may change this later
          <PrivateRoute requiredPermissions={['permission.view']}>
            <GetAdminPermissionById />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/permission/assign"
        element={
          <PrivateRoute requiredPermissions={['permission.assign']}>
            <AssignPermissionToAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/permission/remove"
        element={
          <PrivateRoute requiredPermissions={['permission.revoke']}>
            <RemovePermissionFromAdmin />
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/permission/update"
        element={
          <PrivateRoute requiredPermissions={['permission.edit']}>
            <UpdatePermission />
          </PrivateRoute>
        }
      />
      {/* roles */}
      <Route
        path="/admin/roles/list"
        element={
          <PrivateRoute requiredPermissions={['role.view']}>
            <RoleList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/roles/view/permission"
        element={
          <PrivateRoute requiredPermissions={['role.view']}>
            <ViewRolesPermission />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/roles/create"
        element={
          <PrivateRoute requiredPermissions={['role.create']}>
            <CreateRoles />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/roles/update"
        element={
          <PrivateRoute requiredPermissions={['role.edit']}>
            <UpdateRoles />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/roles/grant/permission"
        element={
          <PrivateRoute requiredPermissions={['role.assign']}>
            <GrantPermissionToRole />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/roles/assign/permission"
        element={
          <PrivateRoute requiredPermissions={['role.assign']}>
            <AssignRoleToAdmin />
          </PrivateRoute>
        }
      />
      {/* ======================end of  Roles and Permission =================== */}
      {/*======================== settings management ====================================*/}

      {/* security question */}
      <Route
        path="/admin/security/question/list"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <GetAllSecurityQuestion/>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/security/questions/details"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <SecurityQuestionDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/security/question/create"
        element={
          <PrivateRoute requiredPermissions={['admin.create']}>
            <CreateSecurityQuestion />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/security/questions/edit"
        element={
          <PrivateRoute requiredPermissions={['admin.edit']}>
            <EditSecurityQuestion />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/security/questions/statistic"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <GetSecurityQuestionStat />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/faq/list"
        element={
          <PrivateRoute requiredPermissions={['']}>
            <ListOfFaq />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/faq/create"
        element={
          <PrivateRoute requiredPermissions={['']}>
            <Faq />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/cluster/location"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <ClusterLocationList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/cluster/location/create"
        element={
          <PrivateRoute requiredPermissions={['admin.create']}>
            <CreateClusterLocation />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/cluster/location/update"
        element={
          <PrivateRoute requiredPermissions={['admin.edit']}>
            <UpdateClusterLocation />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/cluster/location/details"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <ClusterLocationDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/account/2fa/update/status"
        element={
          <PrivateRoute>
            <TwoFactorAuth />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/account/notification/status"
        element={
          <PrivateRoute requiredPermissions={['admin.create']}>
            <NotificationStatus />
          </PrivateRoute>
        }
      />
      {/* ====================== vendor  management====================================== */}
      <Route
        path="/admin/vendor/list"
        element={
          <PrivateRoute requiredPermissions={['vendor.view']}>
            <VendorList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/vendor/details"
        element={
          <PrivateRoute requiredPermissions={['vendor.view']}>
            <VendorDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/vendor/update"
        element={
          <PrivateRoute requiredPermissions={['vendor.edit']}>
            <UpdateVendor />
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/vendor/history"
        element={
          <PrivateRoute>
            <VendorHistory />
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/vendor/withdrawal/request"
        element={
          <PrivateRoute>
            <VendorWithdrawaReqList/>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/vendor/withdrawal/request/approval"
        element={
          <PrivateRoute>
            <VendorWithdrawalApproval />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/vendor/withdrawal/details"
        element={
          <PrivateRoute>
            <VendorWithdrawalrequestDetails />
          </PrivateRoute>
        }
      />

      {/* ====================== end of vendor  management====================================== */}
      {/* ====================== end of settings management ===============================*/}
      <Route
        path="*"
        element={
          <PrivateRoute >
            <PageNotFound />
          </PrivateRoute>
        }
      />
      <Route
        path="/request/error"
        element={
          <PrivateRoute>
            <ErrorPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/password/change"
        element={
          <PrivateRoute>
            <ChangePassword />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/password/forget"
        element={
          <PrivateRoute requiredPermissions={['admin.create']}>
            <ForgetPassword />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/otp/verification"
        element={
          <PrivateRoute >
            <VerifyOTP />
          </PrivateRoute>
        }
      />
      {/*============================ admin settings============================= */}
      {/*============================ bills management============================= */}
      <Route
        path="/admin/product/list"
        element={
          <PrivateRoute requiredPermissions={['bill.view']}>
            <GetBillsProducts />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/list"
        element={
          <PrivateRoute requiredPermissions={['bill.view']}>
            <GetBillsProducts />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/billers/list"
        element={
          <PrivateRoute requiredPermissions={['biller.view']}>
            <GetBillers />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/billers/list/details"
        element={
          <PrivateRoute requiredPermissions={['biller.view']}>
            <GetBillsDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/billers/create"
        element={
          <PrivateRoute requiredPermissions={['biller.create']}>
            <AddBillers />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/billers/update"
        element={
          <PrivateRoute requiredPermissions={['biller.edit']}>
            <UpdateBillers />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/bills/search"
        element={
          <PrivateRoute requiredPermissions={['bill.view']}>
            <SearchBills />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/product/all/list"
        element={
          <PrivateRoute requiredPermissions={['bill.view']} >
            <GetAllProducts />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/billers/view/product"
        element={
          <PrivateRoute requiredPermissions={['biller.view']}>
            <GetBillersProduct />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/switchers/list"
        element={
          <PrivateRoute requiredPermissions={['switcher.view']}>
            <Switcher />
          </PrivateRoute>
        }
      />
      {/*============================ bills management============================= */}
      {/*============================ app setting management============================= */}
      <Route
        path="/admin/appsettings/list"
        element={
          <PrivateRoute requiredPermissions={['settings.view']}>
            <AppSettingList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/appsettings/update"
        element={
          <PrivateRoute requiredPermissions={['settings.edit']}>
            <UpdateAppSettings />
          </PrivateRoute>
        }
      />
      {/*============================ sliders management============================= */}
      <Route
        path="/admin/slider/list"
        element={
          <PrivateRoute requiredPermissions={['settings.view']}>
            <AllSliders />
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/slider/create"
        element={
          <PrivateRoute requiredPermissions={['settings.edit']}>
            <AddSlider />
          </PrivateRoute>
        }
      />
      {/*============================ riders management============================= */}
      <Route
        path="/admin/riders/list"
        element={
          <PrivateRoute requiredPermissions={['rider.view']}>
            <RiderList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/riders/details"
        element={
          <PrivateRoute requiredPermissions={['rider.view']}>
            <RidersDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/riders/update"
        element={
          <PrivateRoute requiredPermissions={['rider.edit']}>
            <EditRider />
          </PrivateRoute>
        }
      />
      {/* pysical product */}
      <Route
        path="/admin/physical/product/list"
        element={
          <PrivateRoute requiredPermissions={['physical.product.view']}>
            <PhysicalProductList />
          </PrivateRoute>
        }
      />
      {/* <Route
        path="/admin/physical/product/create"
        element={
          <PrivateRoute requiredPermissions={['physical.product.create']}>
            <CreatePhysicalProductList />
          </PrivateRoute>
        }
      /> */}
      {/* <Route
        path="/admin/physical/product/edit"
        element={
          <PrivateRoute requiredPermissions={['physical.product.edit']}>
            <EditPhysicalProductList />
          </PrivateRoute>
        }
      /> */}
      {/* </Route> */}

      {/* ======================== OPERATIONS FOR branch ======================================= */}
      <Route
        path="/operations/branch/dashboard"
        element={
          <PrivateRoute >
            <BranchDashboard />
          </PrivateRoute>
        }
      />
      {/*branch */}
      <Route
        path="/operations/branch/list"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchList />
          </PrivateRoute>
        }
      />

      <Route
        path="/operations/branch/create"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <AddBranch />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/details"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/assign-head-office"
        element={
          <PrivateRoute requiredPermissions={['branch.edit']}>
            <AssignBranchToHeadOffice />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/edit"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <EditBranch />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/activity"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BrancActhList />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/wallet/funding"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <FundBranchWallets />
          </PrivateRoute>
        }
      />
      {/* branch customer */}
      <Route
        path="/operations/branch/customer"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchCustomer />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/customer/details"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchCustomerDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/sales"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchSalesHistory />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/sales/details"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchSalesHistoryDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/customer/transactions"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchCustomerTransactionHistory />
          </PrivateRoute>
        }
      />
      {/* branch transactions */}
      <Route
        path="/operations/branch/transactions"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchDetails />
          </PrivateRoute>
        }
      />
      {/* branch product unit */}
      <Route
        path="/operations/branch/product/unit"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <ViewBranchProductUnit />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/product/unit/create"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <CreateBranchProductUnit />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/product/unit/edit"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <EditBranchProductUnit />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/product/unit/details"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchProductUnitDetails />
          </PrivateRoute>
        }
      />
      {/* branch product category */}
      <Route
        path="/operations/branch/products/category"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchProductCat />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/products/category/create"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <AddBranchProductCategory />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/products/category/edit"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <EditBranchProductCategory />
          </PrivateRoute>
        }
      />
      {/* branch product unit crud */}
      <Route
        path="/operations/branch/expenses"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <ExpensesList />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/expenses/show"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <GetExpenseById />
          </PrivateRoute>
        }
      />
      {/* branch products */}
      <Route
        path="/operations/branch/products"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchProductList />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/products/details"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchProductListDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/products/details"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchProductDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/products/create"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <AddBranchProduct />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/products/edit"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <EditBranchProduct />
          </PrivateRoute>
        }
      />
      {/* float */}
      <Route
        path="/operations/branch/floats"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <FloatList />
          </PrivateRoute>
        }
      />
      {/* incentives */}
      <Route
        path="/operations/branch/incentives/pending"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <IncentivesListPending />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/reports"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchReportList />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/customer/reports"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <BranchCustomerReport />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/incentives/stat"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <GetIncentiveStat />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/incentives/details"
        element={
          <PrivateRoute requiredPermissions={['branch.view']}>
            <GetIncentiveById />
          </PrivateRoute>
        }
      />
      {/* <Route
        path="/operations/branch/incentives/create"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <CreateIncentive />
          </PrivateRoute>
        }
      /> */}
      {/* price */}
      <Route
        path="/operations/branch/product/price"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <PriceList />
          </PrivateRoute>
        }
      />
      {/* wallets */}
      <Route
        path="/operations/branch/wallets"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <WalletList />
          </PrivateRoute>
        }
      />
      {/* report */}
      <Route
        path="/operations/branch/report"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <WalletList />
          </PrivateRoute>
        }
      />

      {/* location delivery management */}
      <Route
        path="/admin/delivery/location"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <DeliveryPriceList />
          </PrivateRoute>
        }
      />
      <Route
        path="/delivery/location/price/create"
        element={
          <PrivateRoute requiredPermissions={['admin.create']}>
            <CreateDeliveryPrice />
          </PrivateRoute>
        }
      />
      <Route
        path="/delivery/location/price/details"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <DeliveryPriceDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/delivery/location/price/update"
        element={
          <PrivateRoute requiredPermissions={['admin.create']}>
            <EditDeliveryPrice />
          </PrivateRoute>
        }
      />

      {/* commision module  ....need to ask if it comes with perrmission*/}
      <Route
        path="/admin/commission/list"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <CommissionList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/commission/create"
        element={
          <PrivateRoute requiredPermissions={['admin.create']}>
            <CreateCommission/>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/commission/update"
        element={
          <PrivateRoute requiredPermissions={['admin.edit']}>
            <EditCommission />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/commission/details"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <CommissionDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/commission/assign"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <AssignCommission />
          </PrivateRoute>
        }
      />
      {/* wallets history */}
      <Route
        path="/operations/branch/wallets/history"
        element={
          <PrivateRoute requiredPermissions={['wallet.view']}>
            <WalletsHistory />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/transaction/history"
        element={
          <PrivateRoute requiredPermissions={['admin.view']}>
            <TransactionHistory />
          </PrivateRoute>
        }
      />

      <Route
        path="/operations/branch/purchase/item"
        element={
          <PrivateRoute requiredPermissions={['branch.purchase.view']}>
            <GetAllPurchase />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/purchase/pending"
        element={
          <PrivateRoute requiredPermissions={['branch.purchase.view']}>
            <GetPendingPurchase />
          </PrivateRoute>
        }
      />
      {/*branch stock monitoring */}
      <Route
        path="/operations/branch/stock/monitoring"
        element={
          <PrivateRoute requiredPermissions={['stock.view']}>
            <BranchStockMonitoring />
          </PrivateRoute>
        }
      />
      {/* remittance */}
      <Route
        path="/operations/branch/remittance"
        element={
          <PrivateRoute requiredPermissions={['branch.remittance.view']}>
            <GetAllRemittance />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/remittance/details"
        element={
          <PrivateRoute requiredPermissions={['branch.remittance.view']}>
            <Remittancedetails/>
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/remittance/pending"
        element={
          <PrivateRoute requiredPermissions={['branch.remittance.view']}>
            <GetPendingRemittance />
          </PrivateRoute>
        }
      />

      <Route
        path="/operations/branch/remittance/pending/details"
        element={
          <PrivateRoute requiredPermissions={['branch.remittance.view']}>
            <PendingRemittanceDetails />
          </PrivateRoute>
        }
      />

      <Route
        path="/operations/branch/remittance/process"
        element={
          <PrivateRoute requiredPermissions={['branch.remittance.view']}>
            <GetProcessRemittance />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/remittance/process/details"
        element={
          <PrivateRoute requiredPermissions={['branch.remittance.view']}>
            <ProcessRemittanceDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/remittance/deducted"
        element={
          <PrivateRoute requiredPermissions={['branch.remittance.view']}>
            <GetDeductedRemittance />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/remittance/deducted/details"
        element={
          <PrivateRoute requiredPermissions={['branch.remittance.view']}>
            <DeductedRemittanceDetails />
          </PrivateRoute>
        }
      />
      {/* ========================== END OF OPERATIONS FOR branch===================================== */}

      {/* ========================== HEAD OFFICE ========================================= */}
      <Route
        path="/head-office/dashboard"
        element={
          <PrivateRoute>
            <HeadOfficeDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/head-office/list"
        element={
          <PrivateRoute requiredPermissions={['head_office.view']}>
            <HeadOfficeList />
          </PrivateRoute>
        }
      />
      <Route
        path="/head-office/details"
        element={
          <PrivateRoute requiredPermissions={['head_office.view']}>
            <HeadOfficeDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/head-office/create"
        element={
          <PrivateRoute requiredPermissions={['head_office.create']}>
            <CreateHeadOffice />
          </PrivateRoute>
        }
      />
      <Route
        path="/head-office/edit"
        element={
          <PrivateRoute requiredPermissions={['head_office.edit']}>
            <EditHeadOffice />
          </PrivateRoute>
        }
      />
      <Route
        path="/head-office/inventory"
        element={
          <PrivateRoute requiredPermissions={['head_office.view']}>
            <HeadOfficeInventory />
          </PrivateRoute>
        }
      />
      <Route
        path="/head-office/branches"
        element={
          <PrivateRoute requiredPermissions={['head_office.view']}>
            <HeadOfficeBranches />
          </PrivateRoute>
        }
      />
      <Route
        path="/head-office/allocate-stock"
        element={
          <PrivateRoute requiredPermissions={['head_office.create']}>
            <AllocateStock />
          </PrivateRoute>
        }
      />
      <Route
        path="/head-office/pending-deliveries"
        element={
          <PrivateRoute>
            <HeadOfficePendingDeliveries />
          </PrivateRoute>
        }
      />
      {/* ========================== END OF HEAD OFFICE ===================================== */}

      {/* ========================== BRANCH INVENTORY REQUESTS ===================================== */}
      <Route
        path="/operations/branch/inventory-requests"
        element={
          <PrivateRoute>
            <BranchInventoryRequests />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/inventory-requests/details"
        element={
          <PrivateRoute>
            <BranchInventoryRequestDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/operations/branch/inventory-requests/history"
        element={
          <PrivateRoute>
            <BranchInventoryRequestHistory />
          </PrivateRoute>
        }
      />
      {/* ========================== END OF BRANCH INVENTORY REQUESTS ===================================== */}
    </Route>
  )
);

//this is for react queery----tanstack
// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  const { auth } = useContext(AuthContext);

  return (
    <>
      {/* Render AdminInactivityLogout on all pages  with the below router  */}
      <AdminInactivityLogout auth={auth} />
      <QueryClientProvider client={queryClient}>
        <PortalProvider>
          <RouterProvider router={router} />
        </PortalProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
